import type { IconProps } from '../types/IconProps.ts';
export const MehBlank: IconProps = {
    name: 'MehBlank',
    children: [
        `<path d="M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20" />`,
        `<path d="M8 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M16 10.5a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1" />`,
    ]
};